/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import browser from "utils/browser";
import searchMixin from "./mixins/search-mixin";

// Selectors
const USER_META_GENDER_SELECTOR = 'input[name="meta_gender"]';
const DESIGNER_SLUG_HIDDEN_INPUT_SELECTOR = 'input[name="designer_slug"]';
const BRAND_SEARCH_INPUT_SELECTOR = 'input[name="q"]';

// the gender given by encouraged search is M or F, but the autocomplete services uses Men, Women
const GENDER_FOR_AUTO_COMPLETE = {
    M: "Men",
    F: "Women"
};
const selectors = {
    DELETE_BRAND: "wizard__brand-filter__delete",
    BRAND_FILTER: "wizard__brand-filter"
};
/**
 * The autosuggest - wraps the search input and autosuggest.
 * @constructor
 * @alias module:components/searchInput
 * @extends module:baustein
 */
export default baustein.register("saved-search-brand-search", {
    /** @lends module:components/searchInput.prototype */
    mixins: [searchMixin],
    defaultOptions: {
        brandSearchInputMobilePlaceholder: null,
        isCompact: false
    },
    tagName: "form",

    init() {
        this.initialDesignerSlug = this.el.querySelector(DESIGNER_SLUG_HIDDEN_INPUT_SELECTOR).value;
        const brandList = this.findComponent("saved-search-brand-filter");
        this.brands = {};
        for (const brand of brandList.options.brands) {
            this.brands[brand.name] = brand.slug;
        }
    },
    onInsert() {
        if (
            this.options.isCompact &&
            this.options.brandSearchInputMobilePlaceholder &&
            browser.getViewport() < browser.VIEWPORTS.DESKTOP
        ) {
            this.el
                .querySelector(BRAND_SEARCH_INPUT_SELECTOR)
                .setAttribute("placeholder", this.options.brandSearchInputMobilePlaceholder);
        }
    },

    /**
     * Get the user gender used by autoComplete client from current gender
     */
    getCurrentGender() {
        // handle if value is undefined or ""
        const gender = this.el.querySelector(USER_META_GENDER_SELECTOR).value || "F";
        return GENDER_FOR_AUTO_COMPLETE[gender];
    },

    /**
     * Called by encouraged search to set the gender
     * @param gender string "M" or "F"
     */
    onGenderChange(gender) {
        const genderInput = this.el.querySelector(USER_META_GENDER_SELECTOR);
        genderInput.value = gender;
    },

    /**
     * When the search input is focused we will make sure that the auto-complete component knows
     * the current search term and then show it.
     */
    onFocus() {
        const autoComplete = this._getAutoComplete();
        const query = this.getSearchQuery();

        autoComplete.updateOptions({
            query: query,
            gender: this.getCurrentGender(),
            onlyBrand: true
        });

        this._showAutoComplete();
        this.setGlobalHandler("click", this.onGlobalClick);
        this.emit("brandSearchInputClicked");
    },

    /**
     * Global click event handler. If the click was outside of the component this should close
     * the auto-complete, otherwise it should not do anything.
     * @param  {Event} event
     */
    onGlobalClick(event) {
        if (this.el.contains(event.target)) {
            return;
        }
        this.updateBrandInput();
        this.releaseGlobalHandler("click", this.onGlobalClick);
    },

    updateBrandInput() {
        const autoComplete = this._getAutoComplete();
        const suggestions = autoComplete.getActiveSuggestion();
        if (suggestions) {
            this.onSuggestionSelect(suggestions);
        } else {
            // You end up in this branch when
            // autocomplete returns nothing
            const searchQuery = this.getSearchQuery();
            if (searchQuery === "") {
                this.currentProfileName = null;
                this._setDesignerSlug(null);
            } else {
                this.setSearchQuery(this._getCurrentProfileName());
            }
        }
        this._hideAutoComplete();
    },
    addBrand(brand, slug) {
        this.brands[brand] = slug;
        const brandList = this.findComponent("saved-search-brand-filter");
        const brands = [];
        for (const name of Object.keys(this.brands)) {
            brands.push({ name, slug: this.brands[name] });
        }
        brandList.updateOptions({ brands });
        this._setDesignerSlug();
        this.setSearchQuery("");
    },
    deleteBrand(event, clickedItem) {
        event.preventDefault();
        let brandFilter = clickedItem.parentElement;
        const deletedBrand = brandFilter.dataset["name"];
        delete this.brands[deletedBrand];
        const brandList = this.findComponent("saved-search-brand-filter");
        const brands = [];
        for (const name of Object.keys(this.brands)) {
            brands.push({ name, slug: this.brands[name] });
        }
        brandList.updateOptions({ brands });
        this._setDesignerSlug();
        this.setSearchQuery("");
    },
    clearBrands() {
        const brandList = this.findComponent("saved-search-brand-filter");
        const brands = [];
        brandList.updateOptions({ brands });
        this.brands = {};
        this._setDesignerSlug();
    },
    /**
     * Handler for the user selecting a suggestion in the auto-complete component.
     * @param {object} suggestionObject The suggestions object passed as the event from
     * the auto-complete component.
     */
    onSuggestionSelect({ suggestion }) {
        if (suggestion.type === "profile") {
            this.currentProfileName = suggestion.profile_name;
            const slug = suggestion.path.slice(1, -1);
            this.addBrand(suggestion.profile_name, slug);
            this.el.querySelector(BRAND_SEARCH_INPUT_SELECTOR).textContent = "";
            this.emit("brandChanged");
        }
        this._hideAutoComplete();
    },

    _setDesignerSlug() {
        const designerSlug = Object.keys(this.brands)
            .map(name => this.brands[name])
            .join(",");
        this.el.querySelector(DESIGNER_SLUG_HIDDEN_INPUT_SELECTOR).value = designerSlug;
    },

    _getCurrentProfileName() {
        return this.currentProfileName === undefined ? "" : this.currentProfileName;
    },

    onKeyDown(event) {
        switch (event.keyCode) {
            // enter key
            case 13:
                event.preventDefault();
                this.updateBrandInput();
                this.blur();
                this.emit("inputBlurred");
        }
    },
    setupEvents(add) {
        add("submit", e => e.preventDefault());
        add("click", `.${selectors.DELETE_BRAND}`, this.deleteBrand);
    },
    // You'll end up here when navigating auto complete options using arrow keys
    _getQueryFromSuggestion(suggestionObject) {
        if (suggestionObject && suggestionObject.suggestion.type === "profile") {
            return suggestionObject.suggestion.profile_name;
        }
        return "";
    }
});

